module.exports = __webpack_public_path__ + "static/media/PDF_81.208652cc.pdf";